import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroArrowRight } from '@ng-icons/heroicons/outline';
import { JobOfferService } from 'src/app/api/services';
import { MESSAGES } from 'src/app/core/constant/messages';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { ToastService } from 'src/app/shared/service/toast.service';

@Component({
  selector: 'app-job-offers',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    LoadingComponent,
    NgIcon
  ],
  templateUrl: './job-offers.component.html',
  viewProviders: [provideIcons({heroArrowRight})]
})
export class JobOffersComponent implements OnInit {
  companyId!: string;
  jobOffers: any[] = [];
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private jobOfferService: JobOfferService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.route.parent?.params.subscribe((params) => {
      this.companyId = params['id'];
      if (this.companyId) {
        this.loadJobOffers(this.companyId);
      }
    });
  }

  loadJobOffers(id: string): void {
    this.isLoading = true;
    this.jobOfferService.getJobOffersByCompany(id).subscribe({
      next: (res) => {
        this.jobOffers = res?.dto?.jobOffers.data || [];
        this.isLoading = false;
      },
      error: (err) => {
        const messages = err?.error?.listMessage;
        this.toastService.showMessages('error', [
          messages || MESSAGES.JOB_OFFER.GET_ALL_ERROR,
        ]);
        this.isLoading = false;
      },
    });
  }

  goToDetails(offerId: string) {
    this.router.navigate([
      '/user/company',
      this.companyId,
      'job-offer-details',
      offerId,
    ]);
  }

  goToCreate() {
    this.router.navigate([
      '/user/company',
      this.companyId,
      'job-offer',
      'create',
    ]);
  }
}
